module.exports = __webpack_public_path__ + "img/item_CommIllustration_03a.b4a27014.jpeg";